function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import MaterialDialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
/**
 * The `<Dialog>` component is a type of modal window that appears in front of
 * app content to provide critical information or ask the user to make a
 * decision. Dialogs disable all app functionality when they appear, and remain
 * on screen until confirmed, dismissed, or a required action has been taken.
 *
 * Dialogs are purposefully interruptive, so they should be used sparingly.
 *
 * ~~~js
 * import { Dialog, DialogAction, DialogActions, DialogContent, DialogTitle } from '@theconversation/ui'
 *
 * <Dialog>
 *   <DialogTitle>Title</DialogTitle>
 *   <DialogContent>
 *     <Typography>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Typography>
 *   </DialogContent>
 *   <DialogActions>
 *     <DialogAction variant='primary'>Click Me!</DialogAction>
 *   </DialogActions>
 * </Dialog>
 * ~~~
 */

export var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      open = _ref.open,
      other = _objectWithoutProperties(_ref, ["children", "open"]);

  return React.createElement(MaterialDialog, _extends({}, other, {
    open: open
  }), children);
};
Dialog.propTypes = {
  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node.isRequired,

  /**
   * Overrides the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * The callback function called when the component requests to be closed.
   */
  onClose: PropTypes.func,

  /**
   * A boolean value indicating whether the dialog is currently displayed.
   */
  open: PropTypes.bool
};
Dialog.defaultProps = {
  open: false
};
export default Dialog;